// src/pages/Services.js

import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";


const Services = () => {
  const { t } = useTranslation();
  
  const getListItems = (key) => {
    const items = t(key, { returnObjects: true });
    return Array.isArray(items) ? items : [];
  };

  const allServices = [
    { title: t('services.services.discussIdeas'), img: "001_1", category: "Design" },
    { title: t('services.services.characterDesign'), img: "003_1", category: "Design" },
    { title: t('services.services.bookCover'), img: "002_1", category: "Book" },
    { title: t('services.services.createSketches'), img: "004_1", category: "Design" },
    { title: t('services.services.createChildrensBook'), img: "005_1", category: "Book" },
    { title: t('services.services.graphicDesign'), img: "006_1", category: "Design" },
  ];

  const filters = [
    t('services.filters.allServices'),
    t('services.filters.design'),
    t('services.filters.book')
  ];

  const [activeFilter, setActiveFilter] = useState(t('services.filters.allServices'));

  const filteredServices =
    activeFilter === t('services.filters.allServices')
      ? allServices
      : allServices.filter((service) => 
          service.category === activeFilter.toUpperCase()
        );

  return (
    <>
      <Helmet>
        <title>{t('services.meta.title')}</title>
        <meta
          name="description"
          content={t('services.meta.description')}
        />
        <meta
          name="keywords"
          content={t('services.meta.keywords')}
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://agency.littlehibba.com/services" />
      </Helmet>

      <section className="auth-svc-hero-modern auth-section py-5" style={{ backgroundColor: "var(--background-color)" }}>
        <div className="">
          <div className="container text-center">
            <h1 className="">
              {t('services.hero.title')}
            </h1>
            <p className="">
              {t('services.hero.description')}
            </p>
            <a href="/contact" className="btn-custom mt-4 animate-fade-in-delay">
              {t('services.hero.button')}
            </a>
          </div>
        </div>
      </section>

      <section className="services-content py-5 bg-white">
        <div className="container">
          <div className="row align-items-center mb-5">
            <div className="col-md-6">
              <img 
                src="images/services/013.png" 
                alt={t('services.content.imageAlts.illustrationProcess')} 
                className="img-fluid rounded" 
              />
            </div>
            <div className="col-md-6">
              <h2>{t('services.content.section1.title')}</h2>
              <p>{t('services.content.section1.paragraph1')}</p>
              <p>{t('services.content.section1.paragraph2')}</p>
            </div>
          </div>

          <div className="row align-items-center mb-5 flex-md-row-reverse">
            <div className="col-md-6">
              <img 
                src="images/services/012.png" 
                alt={t('services.content.imageAlts.bookCollection')} 
                className="img-fluid rounded" 
              />
            </div>
            <div className="col-md-6">
              <h3>{t('services.content.section2.title1')}</h3>
              <p>{t('services.content.section2.paragraph1')}</p>

              <h3 className="mt-4">{t('services.content.section2.title2')}</h3>
              <ul>
                {getListItems('services.content.section2.list1').map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <h3>{t('services.content.section2.title3')}</h3>
              <p>{t('services.content.section2.paragraph2')}</p>

              <h3>{t('services.content.section2.title4')}</h3>
              <ul>
                {getListItems('services.content.section2.list2').map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="svc-grid-section py-5">
        <div className="container text-center">
          <h2 className="svc-grid-title mb-4">
            {t('services.servicesSection.title')}
          </h2>

          <div className="mb-4 d-flex flex-wrap justify-content-center gap-2">
            {filters.map((filter, idx) => (
              <button
                key={idx}
                type="button"
                className={`svc-filter-btn btn btn-outline-info px-3 py-2 ${
                  activeFilter === filter ? "svc-filter-active" : ""
                }`}
                onClick={() => setActiveFilter(filter)}
              >
                {filter}
              </button>
            ))}
          </div>

          <div className="row">
            {filteredServices.map((service, i) => (
              <div key={i} className="col-lg-4 col-md-6 mb-4">
                <div className="svc-card card border-0 shadow-sm h-100">
                  <a href="/contact">
                    <img 
                      src={`images/services/${service.img}.png`} 
                      alt={service.title} 
                      className="svc-card-img card-img-top" 
                    />
                  </a>
                  <div className="svc-card-body card-body">
                    <h5 className="svc-card-title card-title">{service.title}</h5>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
         
    </>
  );
};

export default Services;